import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tc" }
const _hoisted_2 = { class: "tc-args text-disabled" }
const _hoisted_3 = {
  key: 0,
  class: "tc-json"
}
const _hoisted_4 = { class: "tc-ret text-medium-emphasis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.call.json ? 'button' : 'div'), {
      class: _normalizeClass(["tc-call", { 'tc-call--expandable': !!_ctx.call.json }]),
      type: _ctx.call.json ? 'button' : undefined,
      "aria-expanded": _ctx.call.json ? String(_ctx.expanded) : undefined,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.call.json && (_ctx.expanded = !_ctx.expanded)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          icon: "mdi-wrench-outline",
          size: "14",
          class: "text-primary"
        }),
        _createElementVNode("code", null, _toDisplayString(_ctx.call.name), 1),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.call.args), 1),
        (_ctx.call.json)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              icon: "mdi-chevron-down",
              size: "16",
              class: _normalizeClass(["tc-caret text-disabled", { 'tc-caret--collapsed': !_ctx.expanded }])
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class", "type", "aria-expanded"])),
    (_ctx.call.json && _ctx.expanded)
      ? (_openBlock(), _createElementBlock("pre", _hoisted_3, _toDisplayString(_ctx.call.json), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.call.ret), 1)
  ]))
}